<template>
  <div class="loader">
    <img class="loader__img" src="/static/skiply_loader.gif" />
  </div>
</template>
<script>
export default {
  name: 'nna-loader',
  data () {
    return {}  
  },
  computed: {
  }      
}
</script>

<style scoped>
.loader {
  position: absolute;
  z-index: 200;
  background: #fff;
  width: 100%;
  height: calc(100% - 56px);
}
.loader__img {
  margin: 0;
  position: relative;            
  top: 50%;                      
  transform: translate(0, -80%)
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter {
  opacity: 1;
}
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// ../nonameapp-common-modules/src/components/Loader/Loader.vue